(function() { window.GUID_1edd99f5_96ca_4ff4_8b3f_d29f69949e2c = { getGuid: function() { return "1edd99f5-96ca-4ff4-8b3f-d29f69949e2c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Snackbar {
            //public static Show(params: Snackbar.Params, autoHideDuration = 5000) {
            //    if (params.id.trim() != "") {
            //        CS.Lag("snackbar", 10, () => {
            //            const $previousSnackbar = $(".snackbar-container");
            //            if ($previousSnackbar.length > 0) {
            //                Snackbar.hide($previousSnackbar, () => {
            //                    Snackbar.show(params, autoHideDuration);
            //                });
            //            } else {
            //                Snackbar.show(params, autoHideDuration);
            //            }
            //        });
            //    }
            //}
            static Show(params, stack) {
                if (params != null) {
                    if (params.Id != null && params.Id.trim() != "") {
                        CS.Lag("snackbar", 10, () => {
                            const $previousSnackbar = $(".snackbar-container").last();
                            if (!stack && $previousSnackbar.length > 0) {
                                Snackbar.hide($previousSnackbar, params.ReloadOnClose, () => {
                                    Snackbar.show(params, stack);
                                });
                            }
                            else {
                                Snackbar.show(params, stack);
                            }
                        });
                    }
                }
            }
            static show(params, stack) {
                let { AutoHideDuration: autoHideDuration } = params;
                //Jai commenté ceci parce qu'on doit pouvoir rien mettre comme temps pour quil reste ouvert indéfiniment
                //if (autoHideDuration == null)
                //    autoHideDuration = 3000;
                const $snackbar = $(Snackbar.createElement(params, stack));
                $(".section-middle").last().append($snackbar);
                $snackbar.animate({ opacity: 1 }, 300, () => {
                    $snackbar.find(".snackbar").addClass("show");
                    if (autoHideDuration) {
                        CS.Lag("snackbar-auto-hide", autoHideDuration, () => {
                            Snackbar.hide($snackbar, params.ReloadOnClose, () => { });
                        });
                    }
                });
                $snackbar.offon("click.snackbar", (e) => {
                    const $target = $(e.target);
                    //Aussi ben de fermer la snack peut importe ou tu click????
                    //if ($target.hasClass("snackbar__close-icon")) {
                    Snackbar.hide($snackbar, params.ReloadOnClose, () => {
                        //params.onClose.call(this);
                    });
                    //}
                });
            }
            static hide($snackbar, reloadOnHide, callback) {
                if ($snackbar.length > 0) {
                    $snackbar.animate({ opacity: 0 }, 300, () => {
                        Snackbar.unbindClickEvent($snackbar);
                        $snackbar.remove();
                        callback.call(this);
                        if (reloadOnHide) {
                            CS.Nav.Refresh();
                        }
                    });
                }
            }
            static createElement(params, stack) {
                let { Id: id, Type: type, Alignment: alignment, Message: txt } = params;
                if (txt) {
                    txt = txt
                        .replace(/\/u003c/gi, "<")
                        .replace(/\/u003e/gi, ">")
                        .replace(/\/u0027/gi, "'")
                        .replace(/\/u0022/gi, "'")
                        .replace(/\/u0026/gi, "&");
                }
                let containerCssClass = "snackbar-container";
                let contentCssClass = "snackbar";
                let txtCssClass = "snackbar__txt";
                let closeIconCssClass = "snackbar__close-icon icon ic-cs-times";
                let containerMargin = "";
                switch (type) {
                    case CS.Enumeration.SnackbarType.Danger:
                        contentCssClass += " snackbar__danger";
                        break;
                    case CS.Enumeration.SnackbarType.Info:
                        contentCssClass += " snackbar__info";
                        break;
                    case CS.Enumeration.SnackbarType.Success:
                        contentCssClass += " snackbar__success";
                        break;
                    case CS.Enumeration.SnackbarType.Warning:
                        contentCssClass += " snackbar__warning";
                        break;
                    default:
                        break;
                }
                switch (alignment) {
                    //case Snackbar.Alignment.TopCenter:
                    //    containerCssClass += " snackbar__top";
                    //    containerCssClass += " snackbar__center";
                    //    break;
                    //case Snackbar.Alignment.TopLeft:
                    //    containerCssClass += " snackbar__top";
                    //    containerCssClass += " snackbar__left";
                    //    break;
                    //case Snackbar.Alignment.TopRight:
                    //    containerCssClass += " snackbar__top";
                    //    containerCssClass += " snackbar__right";
                    //    break;
                    //case Snackbar.Alignment.MiddleCenter:
                    //    containerCssClass += " snackbar__middle";
                    //    containerCssClass += " snackbar__center";
                    //    break;
                    //case Snackbar.Alignment.MiddleLeft:
                    //    containerCssClass += " snackbar__middle";
                    //    containerCssClass += " snackbar__left";
                    //    break;
                    //case Snackbar.Alignment.MiddleRight:
                    //    containerCssClass += " snackbar__middle";
                    //    containerCssClass += " snackbar__right";
                    //    break;
                    case CS.Enumeration.SnackbarAlignment.BottomCenter:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__center";
                        containerMargin = `style="margin-bottom: ${CS.DOM.$sectionBottom.outerHeight()}px"`;
                        break;
                    case CS.Enumeration.SnackbarAlignment.BottomLeft:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__left";
                        containerMargin = `style="margin-bottom: ${CS.DOM.$sectionBottom.outerHeight()}px"`;
                        break;
                    case CS.Enumeration.SnackbarAlignment.BottomRight:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__right";
                        containerMargin = `style="margin-bottom: ${CS.DOM.$sectionBottom.outerHeight()}px"`;
                        break;
                    default:
                        containerCssClass += " snackbar-container__bottom";
                        containerCssClass += " snackbar-container__center";
                        containerMargin = `style="margin-bottom: ${CS.DOM.$sectionBottom.outerHeight()}px"`;
                        break;
                }
                return `<div id="${id}" class="${containerCssClass}" ${containerMargin}>
                        <div class="${contentCssClass}">
                            <div class="${txtCssClass}">${CS.Helper.decodeHTMLEntities(txt)}</div>
                            <div class="${closeIconCssClass}"></div>
                        </div>
                    </div>`;
            }
            static unbindClickEvent($snackbar) {
                $snackbar.off("click.snackbar");
            }
        }
        Controls.Snackbar = Snackbar;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=snackbar.js.map
